import { render, staticRenderFns } from "./fornecedor-extrato.vue?vue&type=template&id=7a4a5f8e&scoped=true"
import script from "./fornecedor-extrato.vue?vue&type=script&lang=js"
export * from "./fornecedor-extrato.vue?vue&type=script&lang=js"
import style0 from "./fornecedor-extrato.vue?vue&type=style&index=0&id=7a4a5f8e&prod&scoped=true&lang=css"
import style1 from "./fornecedor-extrato.vue?vue&type=style&index=1&id=7a4a5f8e&prod&scoped=true&lang=css"
import style2 from "./fornecedor-extrato.vue?vue&type=style&index=2&id=7a4a5f8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4a5f8e",
  null
  
)

export default component.exports